export enum MessageType {
  Text = 1,
  Image = 2,
  Video = 3,
  Document = 4,
}

export interface MessageItem {
  metadata: {
    displayPhoneNumber: string;
  };
  messages: Message[];
}

export interface Message {
  text: {
    body: string;
  };
  from: string;
  timestamp: string;
}

export interface WhatsAppContactResponse {
  contacts: WhatsAppContacts[];
  count: number;
}

export interface WhatsAppMessageResponse {
  messages: WhatsAppMessages[];
  count: number;
}
export interface ApiResponse {
  data: MessageItem[];
}

export interface FilePlaceholder {
  name: string;
  url: string;
  mimeType: string;
}

export interface FilePlaceholderResponse {
  status: boolean;
  code: string;
  filePlaceholders: FilePlaceholder[];
  message: string;
}

export interface FilterKey {
  key: string;
}

export interface MessageHash {
  [key: string]: MessageItem[];
}

export interface WhatsAppContacts {
  contactNumber: string;
  createdAt: string;
  id: string;
  name: string;
  profilePicture: {
    url: string;
    mimeType: string;
  };
  updatedAt: string;
  userId: string;
  unreadCount: number;
  latestMessage: {
    id: string;
    contactId: string;
    message: string;
    timeStamp: string;
    type: MessageType;
    direction: number;
    createdAt: string;
    updatedAt: string;
    media: {
      url: string;
      mimeType: string;
    };
  };
}

export interface Media {
  url: string;
  mimeType: string;
  caption?: string;
  thumbnail?: {
    url: string;
    mimeType: string;
  };
}

export interface WhatsAppMessages {
  id: string;
  contactId: string;
  message: string;
  timeStamp: string;
  direction: number;
  type: string;
  createdAt: string;
  updatedAt: string;
  outgoingMessageType: number;
  date: string;
  media?: Media;
}

export type Timeout = ReturnType<typeof setInterval>;
